exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UuTLM3HtObvxUQlSyXrSa{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;overflow:hidden;height:100%}.UuTLM3HtObvxUQlSyXrSa ._3JxAf0yijOkRpkCx5LzDma,.UuTLM3HtObvxUQlSyXrSa ._6opzkdJw0TEKxT8YVoG6X{width:50%;overflow:auto}", ""]);

// exports
exports.locals = {
	"twoColumnInspector": "UuTLM3HtObvxUQlSyXrSa",
	"itemList": "_6opzkdJw0TEKxT8YVoG6X",
	"itemDetails": "_3JxAf0yijOkRpkCx5LzDma"
};